/* eslint-disable react/prefer-stateless-function */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ContextPages, Link } from 'Components/UI/FacetRouter/FacetRouter';
import Select from 'Components/UI/BehavioralFormElement/Select';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { Tooltip } from 'Components/UI/Tooltip';
import history from 'State/history';
import './index.css';
import { AccountAggregatorModalButton } from 'Components/Modals/AccountAggregator/button';
import { withHousehold } from 'Context/HouseholdContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import { useLayoutContext } from 'Context/LayoutContext';
import Screen from '../../Screens/Screen';

const navigate = (_, value) => {
  history.push(value);
};

const Navigator = ({ children, householdId }) => {
  const { isFocusedLayout } = useLayoutContext();
  const pages = useContext(ContextPages);
  const isMobile = useMobileLayout();
  const options = [{ id: '', key: '', value: 'Jump to screen' }];

  let active = null;
  let index = null;

  for (let i = 0; i < pages.length; i += 1) {
    const page = pages[i];

    if (page?.active === true) {
      active = page;
      index = i;
      break;
    }
  }

  for (let i = 0; i < pages.length; i += 1) {
    options.push({
      id: pages[i].href,
      key: pages[i].href,
      value: pages[i].title,
    });
  }

  return (
    <div className={`${isMobile ? 'questionnaire-screen-container-mobile' : 'questionnaire-screen-container'}`}>
      <div test={active?.title}>
        <PageHeader
          title={active !== null && `${active.title ? active.title : ''}`}
          subtitle="Just click the dropdown to view and update your financial goals and info."
          actions={
            // In focused layout, this button feels out of place, but also, it lets you escape the forced focus mode, which is bad for guidedHouseholdReview
            isFocusedLayout ? null : <AccountAggregatorModalButton householdID={householdId} />
          }
        />
      </div>
      <div className="questionnaire-navigator">
        <div className="questionnaire-navigator-left">
          {index > 0 && (
            <Tooltip
              title={
                pages[index - 1].title ? ` ${pages[index - 1].title}` : ''
              }
              placement="top"
            >
              <Link to={pages[index - 1].href || '/'} tabIndex="-1">
                <FontAwesome icon="angle-left" fontSize="40" />
                <span className="nav-label">Previous</span>
              </Link>
            </Tooltip>
          )}
        </div>
        <div className="questionnaire-navigator-center">
          {active !== null
            && index !== null
            && `${index + 1} of ${pages.length}`}
            &nbsp;
          <div className="select-container">
            <Select
              onChange={navigate}
              options={options}
              value={active?.href}
              tabIndex="-1"
            />
          </div>
        </div>
        <div className="questionnaire-navigator-right">
          {index + 1 < pages.length && (
            <Tooltip
              title={
                pages[index + 1].title ? ` ${pages[index + 1].title}` : ''
              }
              placement="top"
            >
              <Link to={pages[index + 1].href || '/'} tabIndex="-1">
                <span className="nav-label">Next</span>
                <FontAwesome icon="angle-right" fontSize="40" />
              </Link>
            </Tooltip>
          )}
        </div>
      </div>
      <div className={isMobile ? 'questionnaire-screen-mobile' : ''}>
        <Screen index={index}>{children}</Screen>
      </div>
    </div>
  );
};

Navigator.propTypes = {
  children: PropTypes.node.isRequired,
  householdId: PropTypes.string.isRequired,
};

export default withHousehold(Navigator);
